// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".personalCenter .el-form-item__label{color:#4c4d57}.personalCenter .el-input{width:450px}.personalCenter .el-form{width:660px}", ""]);
// Exports
module.exports = exports;
